import styled from "styled-components/macro"

export default styled.section`
  /* overflow-y: auto; */
  position: fixed;
  top: ${props => props.theme.header.height};
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: ${props => props.theme.maxWidth};
  margin: auto;
  background-color: #fff;
  display: flex;
  padding: ${props => props.theme.padding};
  flex-direction: column;
  /* justify-content: space-between; */
  /* align-items: center; */
`

export const Gender = styled.section`
  width: 100%;
  display: flex;
  align-items: center;
  direction: rtl;
  padding: ${props => props.theme.padding} 0;
`

export const Header = styled.div`
`

export const Footer = styled.div`
`